import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getPersonaDecoratorStyles } from './styles/persona';

export const PersonaDecorator = ({
  data: {
    name,
    picture,
    sponsoredText,
  },
  styleOverrides,
}) => {
  const classes = useDefaultStyles(getPersonaDecoratorStyles({ styleOverrides }));

  return (
    <div className={classnames('persona-container', classes.container)}>
      <img className={classnames('persona-picture', classes.picture)} src={picture} alt={name} />
      <div>
        <div className={classnames('persona-name', classes.nameLabel)}>{name}</div>
        <div className={classnames('persona-sponsored', classes.sponsoredLabel)}>{sponsoredText}</div>
      </div>
    </div>
  );
};

PersonaDecorator.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    picture: PropTypes.string.isRequired,
    sponsoredText: PropTypes.string.isRequired,
  }).isRequired,
  styleOverrides: PropTypes.shape({}),
};

PersonaDecorator.defaultProps = {
  styleOverrides: {},
};
